import { FC, MutableRefObject } from 'react'
import { useTranslation } from 'react-i18next'
import {
  GridColumnMenuColumnsItem,
  GridColumnMenuContainer,
  GridColumnMenuPinningItem,
  GridColumnMenuProps,
} from '@microservices/wiskey-react-table-component'
import { GridApiPro } from '@microservices/wiskey-react-table-component/dist/DataGrid/DataGridV7/models/gridApiPro'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'
import ReplayIcon from '@mui/icons-material/Replay'
import { ListItemIcon, MenuItem } from '@mui/material'

type CustomColumnMenuComponentProps = {
  onShowConfig?: (value: boolean) => void
  visibleItems?: string[]
  apiRef?: MutableRefObject<GridApiPro> | null
  handleResetRestrictions?: () => void
  hideShowOptions?: boolean
} & GridColumnMenuProps

export const CustomColumnMenuComponent: FC<CustomColumnMenuComponentProps> = props => {
  const { colDef, hideMenu, visibleItems = ['show', 'pinned', 'autosize', 'reset'] } = props
  const currentColumn = colDef
  const { t } = useTranslation()

  const {
    apiRef,
    handleResetRestrictions,
    hideShowOptions = false,
    onShowConfig,
    ...gridColumnMenuContainerProps
  } = props

  return (
    <GridColumnMenuContainer {...gridColumnMenuContainerProps}>
      {/*<GridColumnMenuHideItem*/}
      {/*  colDef={currentColumn}*/}
      {/*  onClick={e => {*/}
      {/*    hideMenu(e)*/}
      {/*  }}*/}
      {/*/>*/}
      {!hideShowOptions && visibleItems?.includes('show') && (
        <GridColumnMenuColumnsItem
          colDef={currentColumn}
          onClick={e => {
            hideMenu(e)
            onShowConfig(true)
          }}
        />
      )}
      {visibleItems?.includes('pinned') && (
        <GridColumnMenuPinningItem
          colDef={currentColumn}
          onClick={e => {
            hideMenu(e)
          }}
        />
      )}
      {visibleItems?.includes('autosize') && (
        <MenuItem
          onClick={e => {
            /* TODO Отлично работает, когда отключен quickSearch
             *  Но когда включен, autosize у grid'a не видит чекбоксы
             *  Нужно что-то придумать в компоненте HeaderRender
             */
            apiRef.current.autosizeColumns({
              includeHeaders: true,
              includeOutliers: true,
            })
            hideMenu(e)
          }}
        >
          <ListItemIcon>
            <AutoFixHighIcon />
          </ListItemIcon>
          {t('configEntity.view.autosizeColumns')}
        </MenuItem>
      )}
      {visibleItems?.includes('reset') && (
        <MenuItem
          onClick={e => {
            handleResetRestrictions()
            hideMenu(e)
          }}
        >
          <ListItemIcon>
            <ReplayIcon />
          </ListItemIcon>
          {t('configEntity.view.resetRestrictions')}
        </MenuItem>
      )}
    </GridColumnMenuContainer>
  )
}
